<ng-container *transloco="let t; read: 'authentication'">
    <h1>{{t('pageNotFound.title')}}</h1>
    <span>{{t('pageNotFound.message')}}</span>
</ng-container>